import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentBulkSendValues } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: DocumentBulkSendValues) =>
    $actions.document.sendDocumentBulk(dispatch, payload),
  );
};
